module.exports = __webpack_public_path__ + "static/media/plus.e438c2be.svg";